<div class="table-wrapper">
  <div class="filter-section mb-lg-5" *ngIf="withFilter()">
    <div class="filters">
      <div id="status-filter" class="filter-field">
        <div class="d-flex align-items-center">
          <label for="status" class="form-check-label">{{
            'requests.status' | translate
          }}</label>
        </div>
        <div class="filter-input">
          <nz-select
            id="status"
            class="input"
            [nzAllowClear]="true"
            [nzDropdownMatchSelectWidth]="false"
            [nzPlaceHolder]="'All' | translate"
            [class.ltr]="lang == 'ar'"
            [(ngModel)]="selectedStatus"
            (ngModelChange)="changeStatus()"
          >
            <nz-option
              *ngFor="let el of status()"
              [nzValue]="el.key"
              [nzLabel]="el.label | translate"
            >
            </nz-option>
          </nz-select>
        </div>
      </div>
      <div id="service-filter" class="filter-field">
        <div class="d-flex align-items-center">
          <label for="service" class="form-check-label">{{
            'requests.service' | translate
          }}</label>
        </div>
        <div class="filter-input">
          <nz-select
            id="service"
            class="input"
            [nzShowSearch]="true"
            [nzAllowClear]="true"
            [nzDropdownMatchSelectWidth]="false"
            [nzPlaceHolder]="'All' | translate"
            [class.ltr]="lang == 'ar'"
            [(ngModel)]="selectedService"
            (ngModelChange)="changeStatus()"
          >
            <nz-option
              *ngFor="let el of services()"
              [nzValue]="el.id"
              [nzLabel]="lang === 'ar' ? el.titleAr : el.title"
            >
            </nz-option>
          </nz-select>
        </div>
      </div>
      <div id="date-filter" class="filter-field">
        <div class="d-flex align-items-center">
          <label for="input">{{ 'requests.date-filter' | translate }}</label>
        </div>
        <div #pickerWrapper class="filter-input">
          <nz-range-picker
            class="input"
            [(ngModel)]="date"
            (ngModelChange)="onChange($event)"
          ></nz-range-picker>
        </div>
      </div>
      <app-search
        id="request-id-filter"
        class="flex-fill filter-field"
        [placeholder]="'shared.request-Id'"
        (onChange)="onSearch($event)"
      />
    </div>
    <button
      class="action-btn"
      [class.with-logo]="lang == 'ar'"
      (click)="navigateToServices()"
    >
      <i class="fas fa-plus me-3"></i>
      <span>{{ 'requests.new-request' | translate }}</span>
    </button>
  </div>
  <div class="table-content">
    <nz-spin [nzSpinning]="loading()" nzSize="large" style="min-height: 300px">
      <table class="apeco-table table table-striped">
        <thead>
          <tr>
            <th scope="col" class="request-ref-num p-lg-4">
              {{ 'requests.ref-num' | translate }}
            </th>
            <th scope="col" class="request-category p-lg-4">
              {{ 'requests.service-category' | translate }}
            </th>
            <th scope="col" class="request-service p-lg-4">
              {{ 'requests.service-name' | translate }}
            </th>
            <th scope="col" class="request-student p-lg-4">
              {{ 'requests.student-name' | translate }}
            </th>
            <th scope="col" class="request-date p-lg-4">
              {{ 'requests.date' | translate }}
            </th>
            <th scope="col" class="request-status p-lg-4">
              {{ 'requests.status' | translate }}
            </th>
            <th scope="col" class="actions p-lg-4">
              {{ 'requests.actions' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let el of data">
            <td scope="row">
              <span nz-tooltip [nzTooltipTitle]="el.requestNumber">
                {{ el?.requestNumber }}
              </span>
            </td>
            <td>{{ lang == 'en' ? el?.categoryName : el?.categoryNameAr }}</td>
            <td>
              <span
                nz-tooltip
                [nzTooltipTitle]="
                  lang == 'en' ? el?.serviceName : el?.serviceNameAr
                "
                >{{ lang == 'en' ? el?.serviceName : el?.serviceNameAr }}</span
              >
            </td>
            <td>
              <span
                nz-tooltip
                [nzTooltipTitle]="
                  lang == 'en' ? el?.studentName : el?.studentNameAr
                "
                >{{
                  lang == 'en'
                    ? el?.studentName || '--'
                    : el?.studentNameAr || '--'
                }}</span
              >
            </td>
            <td>{{ el.creationDate | arabicDate: 'D MMM YYYY' }}</td>
            <td>
              <span
                [ngClass]="
                  el?.status == 0
                    ? 'draft'
                    : el?.status == 1
                      ? 'in-progress'
                      : el?.status == 2
                        ? 'cancelled'
                        : el?.status == 3
                          ? 'rejected'
                          : el?.status == 4
                            ? 'closed'
                            : el?.status == 5
                              ? 'return-for-correction'
                              : ''
                "
                class="status-badge"
              >
                @if (el?.requestSubstatusName) {
                  <span>{{
                    lang == 'en'
                      ? el?.requestSubstatusName?.en
                      : el?.requestSubstatusName?.ar
                  }}</span>
                } @else {
                  <span>{{
                    lang == 'en' ? el?.statusName?.en : el?.statusName?.ar
                  }}</span>
                }
              </span>
            </td>
            <td>
              <button
                class="action-btn"
                (click)="navigate(el.id, el.serviceCode)"
              >
                {{ 'requests.details' | translate }}
              </button>
            </td>
          </tr>

          <tr *ngIf="!data?.length && !loading()">
            <td colspan="7" class="no-data">
              {{ 'shared.no-data-found' | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </nz-spin>
  </div>
  <div
    class="pagination-content d-flex justify-content-center margin-top"
    *ngIf="withPagination() && !loading()"
  >
    <nz-pagination
      [nzPageIndex]="pageIndex"
      [nzPageSize]="20"
      (nzPageIndexChange)="loadData($event)"
      [nzTotal]="totalElements"
    ></nz-pagination>
  </div>
</div>
